import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { isPermissible } from '../PermissionResolver';
import { AppContext } from '../../../AppProvider';
import _get from 'lodash/get';
export class PermitButton extends PureComponent {
  static propTypes = {
    permission: PropTypes.string.isRequired,
    type: PropTypes.string,
    variant: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    classes: PropTypes.object,
    disableRipple: PropTypes.bool,
    onClick: PropTypes.func,
    to: PropTypes.string
  };

  render() {
    const {
      permission,
      type = null,
      classes = null,
      variant = 'contained',
      color = 'primary',
      disableRipple = false,
      onClick = null,
      to = null,
      children
    } = this.props;
    const isPermitted = isPermissible(this.context.globalProps, permission);
    const className = _get(classes, 'button' || '');

    let buttonToRender = (
      <Button
        className={className}
        classes={classes}
        type={type}
        variant={variant}
        color={color}
        disableRipple={disableRipple}
      >
        {children}
      </Button>
    );

    if (onClick) {
      buttonToRender = (
        <Button
          className={className}
          classes={classes}
          type={type}
          variant={variant}
          color={color}
          disableRipple={disableRipple}
          onClick={onClick}
        >
          {children}
        </Button>
      );
    } else if (to) {
      buttonToRender = (
        <Button
          className={className}
          classes={classes}
          type={type}
          variant={variant}
          color={color}
          disableRipple={disableRipple}
          component={Link}
          to={to}
        >
          {children}
        </Button>
      );
    }

    return isPermitted && buttonToRender;
  }
}

PermitButton.contextType = AppContext;
export default PermitButton;
